import React, { useEffect, useRef, useState } from "react";
import AccordionComponent from "../../../../../common/Accordion";
import {
  Button,
  Col,
  Container,
  Form,
  Modal,
  OverlayTrigger,
  Row,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
} from "react-bootstrap";
import { PICKLIST_GROUP_NAME, WEB_ROLE } from "../../../../../common/Constant";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../redux/Store";
import { fetchPickListByGroupName } from "../../../../../services/CaseInformationApi";
import SearchableSingleSelectDropdown from "../../../../../common/SearchableDropdown";
import SearchableMultiSelectDropdown from "../../../../../common/SearchableMultiSelectDropdown";
import NumberInput from "../../../../../common/NumberInput";
import MultilineTextBox from "../../../../../common/MultilineTextBox";
import TextInput from "../../../../../common/TextInput";
import Snackbar from "../../../../../common/Snackbar";
import {
  addBillingStandardCharges,
  getBillingStandardChargesEditDetails,
  getBillingStdChargesChangeLog,
  updateBillingStandardCharges,
} from "../../../../../services/BillingAPI";
import Loader from "../../../../../common/Loader";
import ChangeLogDrawer from "../Configuration/ChangeLogDrawer";
import BillingDataTable from "../BillingDataTable";
import { BILLING_CONFIG_CHANGE_LOG } from "../../actions/constant";
import { formatAppointmentDateTime } from "../../../../../utils/dateUtils";
import { getBillingDashboardClientList } from "../../../../../services/BillingDashboardAPI";
import CurrencyInputWithType from "../../../../../common/CurrencyInputWithType";

const AddUpdateStandardCharges = ({ onClose, selectedRowData }: any) => {
  const userID = useSelector((state: RootState) => state.auth.userid);
  const [chargesName, setChargesName] = useState("");
  const [description, setDescription] = useState("");
  const [caseTypeOptions, setCaseTypeOptions] = useState<any[]>([]);
  const [selectedCaseType, setSelectedCaseType] = useState<(string | number)[]>(
    [],
  );
  const [examTypeOptions, setExamTypeOptions] = useState<any[]>([]);
  const [selectedExamType, setSelectedExamType] = useState<(string | number)[]>(
    [],
  );
  const [casePriorityOptions, setCasePriorityOptions] = useState<any[]>([]);
  const [selectedCasePriority, setSelectedCasePriority] = useState<
    string | number
  >("");
  const [currencyOptions, setCurrencyOptions] = useState<any[]>([]);
  const [clientOptions, setClientOptions] = useState<any[]>([]);
  const [selectedClient, setSelectedClient] = useState<any>(null);
  const [selectedCurrency, setSelectedCurrency] = useState("");
  const [selectedCurrencyLabel, setSelectedCurrencyLabel] = useState("");
  const [fixedAmount, setFixedAmount] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [comments, setComments] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [error, setError] = useState("");
  const [showModalNew, setShowModalNew] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [configurationBillingKey, setConfigurationBillingKey] = useState<
    string | null
  >("0");
  const [changeLogData, setChangeLogData] = useState<any[]>([]);
  const [showTooltip, setShowTooltip] = useState(false);
  const [showChangeDrawer, setShowChangeDrawer] = useState(false);
  const [createdOn, setCreatedOn] = useState("");
  const [createdBy, setCreatedBy] = useState("");
  const [selectedBaseCurrency, setSelectedBaseCurrency] = useState("USD");
  const [baseAmount, setBaseAmount] = useState<any>("");
  const [selectedClientCurrency, setSelectedClientCurrency] = useState("USD");
  const [clientAmount, setClientAmount] = useState<any>("");
  

  const params = {
    caseType: {
      groupName: PICKLIST_GROUP_NAME.Case_Review_Type,
      triggerById: userID,
    },
    examType: {
      groupName: PICKLIST_GROUP_NAME.Appointment_Type,
      triggerById: userID,
    },
    casePriority: {
      groupName: PICKLIST_GROUP_NAME.Case_Priority,
      triggerById: userID,
    },
  };

  const currencyData = [
    {
      label: "USD",
      value: "USD",
    },
    {
      label: "INR",
      value: "INR",
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [clientList, casePriorityData, caseTypeData, examTypeData] =
          await Promise.all([
            getBillingDashboardClientList(),
            fetchPickListByGroupName(params.casePriority),
            fetchPickListByGroupName(params.caseType),
            fetchPickListByGroupName(params.examType),
          ]);
        
        setClientOptions(clientList || []);
        setCasePriorityOptions(casePriorityData || []);
        setCaseTypeOptions(caseTypeData || []);
        setExamTypeOptions(examTypeData || []);
        setCurrencyOptions(currencyData);
        if(!selectedRowData?.billingConfigStdChgId){
          setSelectedCasePriority(casePriorityData?.[0]?.value);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const fetchStandardChargeDetails = async () => {
    const detailList = await getBillingStandardChargesEditDetails(
      selectedRowData?.billingConfigStdChgId,
    );
    const changeLogData = await getBillingStdChargesChangeLog(
      selectedRowData?.billingConfigStdChgId,
    );
    if (!detailList) return;
    setChargesName(detailList.standardChargeNote || "");
    setDescription(detailList.standardChargeDesc || "");
    setSelectedClient(detailList?.clientId || null);
    setSelectedCasePriority(detailList.priorityId);
    setSelectedCaseType(
      detailList.caseTypeIdCsv
        ? detailList.caseTypeIdCsv.split(",").map(Number)
        : [],
    );
    setSelectedExamType(
      detailList.examTypeIdCsv
        ? detailList.examTypeIdCsv.split(",").map(Number)
        : [],
    );
    setSelectedCurrency(detailList.currencyType || "");
    setSelectedBaseCurrency(detailList.currencyType || "");
    setBaseAmount(detailList.standardChargeRate || "");
    setClientAmount(detailList.clientRateStandardChargeRate || "");
    setFixedAmount(detailList.standardChargeRate?.toString() || "");
    setIsActive(detailList.isActive === 1);
    setComments(detailList.comments || "");
    setCreatedOn(
      detailList.createdDate
        ? formatAppointmentDateTime(detailList.createdDate)
        : "",
    );
    setCreatedBy(detailList.createdByName ? detailList.createdByName : "");
    if (changeLogData) {
      const filteredLogData = changeLogData?.filter(
        (item: any) =>
          !["modifieddate", "modifiedby"].includes(
            item.fieldUpdated?.toLowerCase(),
          ),
      );
      setChangeLogData(filteredLogData || []);
    }
  };

  useEffect(() => {
    if (selectedRowData?.billingConfigStdChgId) {
      fetchStandardChargeDetails();
    }
  }, [selectedRowData]);

  const handleCasePriorityChange = (val: string | number) => {
    setSelectedCasePriority(val);
  };

  const handleCurrencyChange = (e: any) => {
    const selectedValue = e.target.value;

    const selectedOption = currencyOptions.find(
      (opt) => String(opt.value) === String(selectedValue),
    );

    setSelectedCurrency(selectedValue);
    setSelectedCurrencyLabel(selectedOption?.label || "");
  };

  const handleIsActive = () => {
    setIsActive((prev) => !prev);
  };

  const validateCharges = () => {
    const errors = [];

    if (!chargesName) {
      errors.push("Charge Name is mandatory.");
    }

    if (!selectedClient) {
      errors.push("Client is mandatory.");
    }

    if (!selectedCasePriority) {
      errors.push("Case Priority is mandatory.");
    }

    if (!selectedCaseType || selectedCaseType?.length === 0) {
      errors.push("Case Type is mandatory.");
    }

    if (!selectedExamType || selectedExamType?.length === 0) {
      errors.push("Exam Type is mandatory.");
    }

    if (!baseAmount) {
      errors.push("Base Rate is mandatory.");
    }

    if (baseAmount && Number(baseAmount) === 0) {
      errors.push("Base Rate cannot be zero.");
    }

    if (!clientAmount) {
      errors.push("Client Rate is mandatory.");
    }

    if (clientAmount && Number(clientAmount) === 0) {
      errors.push("Client Rate cannot be zero.");
    }

    if (errors?.length > 0) {
      setSnackbarMessage(errors.join("\n"));
      setSnackbarOpen(true);
      setError("error");
      return false;
    }

    return true;
  };

  const handleSaveCharges = async () => {
    if (!validateCharges()) return;
    setLoading(true);
    const isUpdate = !!selectedRowData?.billingConfigStdChgId;
    const payload = {
      billingConfigStdChgId: isUpdate
        ? Number(selectedRowData?.billingConfigStdChgId)
        : null,
      standardChargeNote: chargesName.trim(),
      standardChargeDesc: description.trim(),
      clientId: Number(selectedClient),
      priorityId: Number(selectedCasePriority),
      caseTypeIdCsv: selectedCaseType.join(","),
      examTypeIdCsv: selectedExamType.join(","),
      currencyType: selectedBaseCurrency,
      standardChargeRate: Number(baseAmount),
      clientRateStandardChargeRate: Number(clientAmount),
      comments: comments.trim(),
      isActive: isActive ? 1 : 0,
    };
    try {
      const response = isUpdate
        ? await updateBillingStandardCharges(payload)
        : await addBillingStandardCharges(payload);

      if (response?.isSuccess) {
        setSnackbarMessage(
          isUpdate
            ? "Billing Standard Charges updated successfully"
            : "Billing Standard Charges Added successfully",
        );
        setError("success");
        setSnackbarOpen(true);
        setTimeout(() => {
          onClose();
        }, 800);
      } else {
        setSnackbarMessage(response?.message || "Failed to process data.");
        setError("error");
        setSnackbarOpen(true);
      }
    } catch (error: any) {
      setSnackbarMessage(error.message || "Something went wrong");
      setError("error");
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const resetData = () => {
    setChargesName("");
    setDescription("");
    setSelectedCaseType([]);
    setSelectedExamType([]);
    setSelectedCasePriority(casePriorityOptions[0]?.value);
    setSelectedCurrency("");
    setSelectedCurrencyLabel("");
    setFixedAmount("");
    setIsActive(true);
    setComments("");
  };

  const handleCancelButton = () => {
    setShowModalNew(true);
  };

  const handleAccordionSelect = (key: string | null) => {
    if (configurationBillingKey === key) {
      return;
    }
    setConfigurationBillingKey(key || "0");
  };

  const handleCloseModalNew = () => {
    setShowModalNew(false);
  };

  const handleConfirmCancelButton = () => {
    if (selectedRowData?.billingConfigStdChgId) {
      fetchStandardChargeDetails();
    } else {
      resetData();
    }
    setShowModalNew(false);
  };

  const handleOpenChangeDrawer = () => {
    setShowTooltip(false);
    setShowChangeDrawer(true);
  };

  const handleCloseChangeDrawer = () => {
    setShowChangeDrawer(false);
  };

  const configurationAccordion = (
    items: { title: string; content: JSX.Element }[],
  ) => (
    <AccordionComponent
      items={items.map((item) => ({ ...item }))}
      activeKey={configurationBillingKey}
      onSelect={handleAccordionSelect}
    />
  );

  return (
    <div>
      {" "}
      <Container fluid className="px-1 mt-4 mb-5">
        <Loader isLoading={loading} />
        <Snackbar
          open={snackbarOpen}
          message={snackbarMessage}
          onClose={() => setSnackbarOpen(false)}
          severity={error}
        />
        {configurationAccordion([
          {
            title: "Configure Standard Charges",
            content: (
              <>
                <Row className="align-items-center mt-3">
                  <Col xs={6}>
                    <TextInput
                      label="Charge Name"
                      name="name"
                      required={true}
                      value={chargesName}
                      maxLength={100}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        let value = e.target.value;
                        if (value.startsWith(" ")) return;
                        value = value.replace(/\s{2,}/g, " ");
                        setChargesName(value);
                      }}
                    />
                  </Col>
                  <Col xs={6}>
                    <TextInput
                      label="Description"
                      name="desc"
                      value={description}
                      maxLength={500}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        let value = e.target.value;
                        if (value.startsWith(" ")) return;
                        value = value.replace(/\s{2,}/g, " ");
                        setDescription(value);
                      }}
                    />
                  </Col>
                </Row>
                <Row className="align-items-center mt-3">
                  <Col sm={3} className="selection_dropdown">
                    <SearchableSingleSelectDropdown
                      label="Client"
                      value={selectedClient}
                      options={clientOptions}
                      onChange={(e) =>
                        setSelectedClient(e.target.value)
                      }
                      name="client"
                      required={true}
                    />
                  </Col>
                  <Col sm={3} className="selection_dropdown">
                    <SearchableSingleSelectDropdown
                      label="Case Priority"
                      value={selectedCasePriority}
                      options={casePriorityOptions}
                      onChange={(e) =>
                        setSelectedCasePriority(e.target.value)
                      }
                      name="casePriority"
                      required={true}
                    />
                  </Col>
                  <Col sm={3} className="selection_dropdown">
                    <SearchableMultiSelectDropdown
                      label="Case Type"
                      name="caseType"
                      options={caseTypeOptions}
                      values={selectedCaseType}
                      onChange={(e, name, values) =>
                        setSelectedCaseType(values)
                      }
                      required
                      isSelectAll={true}
                    />
                  </Col>
                  <Col sm={3} className="selection_dropdown">
                    <SearchableMultiSelectDropdown
                      label="Exam Type"
                      name="examType"
                      options={examTypeOptions}
                      values={selectedExamType}
                      onChange={(e, name, values) =>
                        setSelectedExamType(values)
                      }
                      required
                         isSelectAll={true}
                    />
                  </Col>
                </Row>
                <Row className="align-items-center mt-3">
                  <Col sm={3}>
                    <CurrencyInputWithType
                      label="Base Rate"
                      name="base"
                      value={baseAmount}
                      onChange={(e) => setBaseAmount(e.target.value)}
                      allowDecimal={true}
                      limit={[8, 2]}
                      required
                      disabled={!selectedBaseCurrency}
                      showAmountLabel={true}
                      currencyOptions={currencyOptions}
                      selectedCurrency={selectedBaseCurrency}
                      onCurrencyChange={(val) =>
                        setSelectedBaseCurrency(val)
                      }
                    />
                  </Col>
                  <Col sm={3}>
                    <CurrencyInputWithType
                      label="Client Rate"
                      name="client"
                      value={clientAmount}
                      onChange={(e) => setClientAmount(e.target.value)}
                      allowDecimal={true}
                      limit={[8, 2]}
                      required
                      disabled={!selectedClientCurrency}
                      showAmountLabel={true}
                      currencyOptions={currencyOptions}
                      selectedCurrency={selectedClientCurrency}
                      onCurrencyChange={(val) =>
                        setSelectedClientCurrency(val)
                      }
                      currencyDisabled={true}
                    />
                  </Col>
                  <Col sm={6} md={4}>
                    <div className="d-flex align-items-center toggle-btn">
                      <span className="me-3 fw-semibold">Status</span>

                      <Form.Check
                        type="switch"
                        id="sort-switch"
                        checked={isActive}
                        onChange={handleIsActive}
                      />
                      <span className="ms-2">
                        {isActive ? "Active" : "In Active"}
                      </span>
                    </div>
                  </Col>
                </Row>

                <Col
                  sm={12}
                  className="mt-3 notemultiline notemultilinerushnote  mb-3"
                >
                  <MultilineTextBox
                    label="Comments"
                    name="comments"
                    value={comments}
                    onChange={(e) => {
                      let value = e.target.value;
                      if (value.startsWith(" ")) return;
                      value = value?.trimStart();
                      value = value.replace(/ {2,}/g, " ");
                      setComments(value);
                    }}
                    maxLength={100}
                  />
                </Col>
                <Row className="mt-3 mb-3">
                  <Col sm={12} className="d-flex align-items-center">
                    {changeLogData?.length > 0 && selectedRowData && (
                      <OverlayTrigger
                        show={showTooltip}
                        placement="auto"
                        trigger={["hover", "focus"]}
                        delay={{ show: 200, hide: 100 }}
                        overlay={
                          <Tooltip style={{ backgroundColor: "#b3e0ff" }}>
                            Logs
                          </Tooltip>
                        }
                      >
                        <div className="d-flex">
                          <Button
                            type="button"
                            className="btn btn-primary d-flex align-items-center mx-2"
                            onClick={handleOpenChangeDrawer}
                            onMouseEnter={() => setShowTooltip(true)}
                            onMouseLeave={() => setShowTooltip(false)}
                          >
                            <span className="material-icons">description</span>
                          </Button>
                        </div>
                      </OverlayTrigger>
                    )}
                    <Button
                      variant="outline-info"
                      className="d-flex align-items-center me-auto btn-text-border"
                      onClick={onClose}
                    >
                      <span className="material-icons me-1">arrow_back</span>
                      Back
                    </Button>

                    <Button
                      variant="outline-info"
                      className="d-flex align-items-center"
                      onClick={handleCancelButton}
                    >
                      <span className="material-icons me-1">close</span>
                      Cancel
                    </Button>
                    <Button
                      type="submit"
                      variant="primary"
                      className="ms-3 d-flex align-items-center"
                      onClick={handleSaveCharges}
                    >
                      <span className="material-icons me-1">save</span>
                      Save
                    </Button>
                  </Col>
                </Row>
              </>
            ),
          },
        ])}
        <Modal show={showModalNew} onHide={handleCloseModalNew}>
          <Modal.Body className="fw-bold text-left modelheading ">
            <div>Are you sure you want to cancel?</div>
          </Modal.Body>
          <Modal.Footer className="border-top d-flex justify-content-end">
            <Button
              variant="outline-info"
              className="d-flex align-items-end"
              onClick={handleCloseModalNew}
            >
              <span className="material-icons mr-2">close</span> Cancel
            </Button>
            <Button
              onClick={handleConfirmCancelButton}
              variant="primary"
              className="ms-3 d-flex align-items-center"
            >
              <span className="material-icons mx-1">check</span> Confirm
            </Button>
          </Modal.Footer>
        </Modal>

        <ChangeLogDrawer
          title={"Change Log"}
          open={showChangeDrawer}
          onClose={handleCloseChangeDrawer}
          placement="bottom"
          data={changeLogData}
          createdOn={createdOn}
          createdBy={createdBy}
        >
          <BillingDataTable
            headers={BILLING_CONFIG_CHANGE_LOG}
            rows={changeLogData}
            isLogTable={true}
          />
        </ChangeLogDrawer>
      </Container>
    </div>
  );
};

export default AddUpdateStandardCharges;
